import _ from 'lodash';
import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import filesize from 'filesize';
import moment from 'moment';
import { FormattedMessage, intlShape, injectIntl } from 'react-intl';
import withStyles from 'isomorphic-style-loader/withStyles';
import { connect } from 'react-redux';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';

import s from './Attachment.scss';
import fileStyles from '../../../components/file-icons.css'; // eslint-disable-line css-modules/no-unused-class

import messages from './messages';

@injectIntl
@withStyles(s)
@withStyles(fileStyles)
@connect(state => ({
  lesson: state.lessonDetails.lesson,
}))
export default class Attachment extends React.Component {
  static propTypes = {
    lesson: PropTypes.shape({
      _id: PropTypes.string.isRequired,
    }).isRequired,
    item: PropTypes.shape({
      _id: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      type: PropTypes.string.isRequired,
      size: PropTypes.number.isRequired,
      uploadedDate: PropTypes.string.isRequired,
      path: PropTypes.string.isRequired,
      mimetype: PropTypes.string.isRequired,
    }).isRequired,
    withVideo: PropTypes.bool.isRequired,
    actionBtn: PropTypes.node,
    intl: intlShape.isRequired,
  };

  static defaultProps = {
    actionBtn: null,
  };

  static contextTypes = {
    apiUrl: PropTypes.string,
  };

  render() {
    const { lesson, withVideo, item, actionBtn } = this.props;

    return (
      <div className={classNames(s.item, withVideo ? s.withVideo : undefined)}>
        <div
          className={classNames(s.icon, fileStyles.file, fileStyles[item.type])}
        />
        <div
          className={classNames(s.info, withVideo ? s.withVideo : undefined)}
        >
          <Typography
            variant="h5"
            className={classNames(
              s.fileName,
              withVideo ? s.withVideo : undefined,
            )}
          >
            {item.name}
          </Typography>
          <div className={s.details}>
            <div>
              <Typography variant="body1" className={s.attrTitle}>
                <FormattedMessage {...messages.type} />
              </Typography>{' '}
              {_.toUpper(item.type)}
            </div>
            <div>
              <Typography variant="body1" className={s.attrTitle}>
                <FormattedMessage {...messages.size} />
              </Typography>{' '}
              {filesize(item.size)}
            </div>
            <div>
              <Typography variant="body1" className={s.attrTitle}>
                <FormattedMessage {...messages.uploaded} />
              </Typography>{' '}
              {moment(item.uploadedDate).format('DD/MM/YYYY HH:mm')}
            </div>
          </div>
        </div>
        <div className={classNames(s.btn, withVideo ? s.withVideo : undefined)}>
          {!actionBtn && (
            <Button
              variant="outlined"
              color="primary"
              size="large"
              component="a"
              href={`${this.context.apiUrl}/api/lessons/${lesson._id}/attachments/${item._id}`}
              target="_blank"
              fullWidth
            >
              <FormattedMessage {...messages.download} />
            </Button>
          )}
          {actionBtn}
        </div>
      </div>
    );
  }
}
